import React, { FunctionComponent } from 'react';
import { Dropdown, Image } from 'semantic-ui-react';
import { pathOr } from 'ramda';
import withStyles from 'react-jss';

import { Profile } from 'components/UserMgmt/UserMgmt.helpers';
import ShowLogout from '../ShowLogout';
import styles from 'components/Header/components/SecondaryNav/SecondaryNav.styles';
import { GET_MERCHANT } from 'components/Header/components/SecondaryNav/SecondaryNav.queries';
import Query from 'components/Query';
import { BrandAsset } from 'scenes/Home/components/MerchantCard/MerchantCard.helper';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  profile: Profile;
};

type Merchant = {
  merchantId: string;
  merchantName: string;
  logo: string;
  brandAssets: BrandAsset;
};

export type QueryResponse = {
  loading: boolean;
  data: {
    merchantList: {
      result: Merchant[];
    };
  };
};

const trigger = (logo: string, givenName: string, familyName: string) => (
  <span>
    <Image avatar src={logo} /> {`${givenName} ${familyName}`}
  </span>
);

const renderExternalSubNav = ({ classes, profile }: Props) => (
  response: QueryResponse,
) => {
  const { givenName, familyName } = profile;
  const { loading, data } = response;

  if (loading) return null;

  const merchants = pathOr([], ['merchantList', 'result'], data) as Merchant[];
  const { logo, brandAssets }: Merchant = merchants[0] || '';
  const merchantLogo = pathOr(logo, ['image', 'icon', 'path'], brandAssets);

  return (
    <Dropdown
      item
      trigger={trigger(merchantLogo, givenName, familyName)}
      className={classes.dropDown}
    >
      <Dropdown.Menu className={classes.dropDownMenu}>
        <ShowLogout />
      </Dropdown.Menu>
    </Dropdown>
  );
};

const ExternalSubNav: FunctionComponent<Props> = (props) => {
  const { merchantId } = props.profile;

  return (
    <Query
      enableProgressInfo
      query={GET_MERCHANT}
      render={renderExternalSubNav(props)}
      variables={{
        params: {
          merchantId,
        },
        package: 'DEFAULT_BRANDING',
      }}
    />
  );
};

export default withStyles(styles)(ExternalSubNav);
